import { render, staticRenderFns } from "./AlertTrigger.vue?vue&type=template&id=2b358858&"
import script from "./AlertTrigger.vue?vue&type=script&lang=js&"
export * from "./AlertTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports